<script>

import { Overlay } from '../../'

export default {
    name: 'LT',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'Laser Target',
                preset: {
                    name: 'LT $smaLength, $dcLength, $riskRewardRatio',
                    group: 'Visual Trading',
                    side: 'onchart',
                    settings: {
                        smaLength: 50,
                        dcLength: 20,
                        riskRewardRatio: 3,
                        showPendingTarget: true,
                        lineWidth: 2
                    }
                }
            }
        },
        use_for() { return ['LT'] },
        calc() {
            return {
                props: {
                    smaLength: { def: 50, text: 'SMA Length' },
                    dcLength: { def: 20, text: 'DC Length' },
                    riskRewardRatio: { def: 3, text: 'Risk Reward Ratio' },
                    showPendingTarget: { def: true, text: 'Show Pending Target' }
                },
                conf: { renderer: 'VTLaser' }
            }
        }
    }
}
</script>
